// @ts-nocheck

import React, { useRef, useLayoutEffect, useState } from 'react';
import type { ElementRef } from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  &&&& {
    overflow: visible;
  }
  text {
    text-anchor: middle;
    font-size: 16px;
    line-height: 1;
  }
`;

const Fake = styled(Svg)`
  visibility: hidden;
  position: absolute;
`;

type WinModalAnimationFitTextProps = {
  text: string;
  className?: string;
};

const WinModalAnimationFitText = ({ text, className }: WinModalAnimationFitTextProps) => {
  const [viewBox, setViewBox] = useState<{ width: number; height: number }>({ width: 0, height: 0 });
  const refText = useRef<ElementRef<'text'> | null>(null);
  useLayoutEffect(() => {
    if (refText.current) {
      const { width, height } = refText.current.getBoundingClientRect();
      setViewBox({ width, height });
    }
  }, [text, refText]);
  return (
    <>
      <Svg className={className} viewBox={`0 0 ${viewBox.width} ${viewBox.height}`} fill="currentColor">
        <text x={viewBox.width / 2} y="100%">
          {text}
        </text>
      </Svg>
      <Fake>
        <text ref={refText}>{text}</text>
      </Fake>
    </>
  );
};

export default WinModalAnimationFitText;
